module.exports = __webpack_public_path__ + "static/img/IT@3x.94f7109e.jpg";